import { useEffect, useState, useMemo } from "react";
import PremiumPageHeader from '../../components/PremiumPageHeader';
import { ListPageFloatingControls } from '../../components/ListPageLayout';
import ReactTableWrapper from "../../components/ReactTableWrapper";
import { exportAsCSV } from "../../utils/CSVExporter";
import { exportAsPDF } from "../../utils/PDFExporter";
import { useNavigate } from "react-router-dom";
import "../../App.css";
import Sidebar from '../../Sidebar';
import Swal from "sweetalert2";
import { useCookies } from 'react-cookie';
import { getAllPermission, deletePermission } from "../../services/PermissionServices";
import { displayError } from "../../helpers";
function PermissionTable() {
    const InitialData = {
        total_pages: 0,
        records: [],
      };
    const [data, setData] = useState(InitialData);
    const navigate = useNavigate(); 
    const [refreshKey, setRefreshKey] = useState(0);
    const [cookies] = useCookies(['myToken']);
    const [isLoading, setIsLoading] = useState(true); 

    const columns = useMemo(
        () => [
            {
                fieldName: 'name', 
                headerName: 'Category Name'
            },
           
            
            {
                fieldName: "id",
                headerName: "ROW_ACTIONS"
            }
       
         
        ],
        [],);

    const onEditPermission = (permissionId, event) => {
       
       navigate(`/PermissionEdit/${permissionId}/`);
    };

    const onDeletePermission = (permissionId, event) => {

        event.preventDefault();
        Swal.fire({title: 'Are you sure to Delete?',  
        showCancelButton: true,  
        confirmButtonText: `Yes`,  
        cancelButtonText: `No`,
        }).then((result) => {  
            if (result.isConfirmed) { 

                setIsLoading(true);
                deletePermission(cookies, permissionId)
                .then(response => {
                    console.log(`Permission with id ${permissionId} deleted`);
                    setRefreshKey(oldKey => oldKey +1);
                    Swal.fire('Deleted Successfully!', '', 'success');
                })
                .catch(error => {
                    console.log(error.response.data);
                    displayError(error.response.data,'Delete Failed');
                }); 
                
                
              } else if (result.isDismissed) {    
            Swal.fire('Not Deleted', '', 'info')  
        }
        });
        //

    };

    const handleCSVExport = (event) => {
        console.log('CSV Export');
        exportAsCSV(
            columns
            .filter(col => col.headerName !== 'ROW_ACTIONS')
            .map(c => c.headerName),
            data.records.map(r => {

                const csvRow = {
                    name: r.name
                  
                    
                }
                return csvRow;
                }));
    };

    const handlePDFExport = (event) => {
        console.log('PDF Export');
        exportAsPDF(
            'List of Permission Form',
            columns
            .filter(col => col.headerName !== 'ROW_ACTIONS')
            .map(col=>({header: col.headerName, dataKey: col.fieldName })),
            data.records.map(r => ({
                name: r.name
             
            })),
            'Permission_Forms.pdf'
        );
    };

    useEffect(() => {

        getAllPermission(cookies)
        .then( permissionList => {
            const tableData = permissionList.group_list
            .map(r => ({
            id :r.id,
            name: r.name,
              
            }));

            setData({
                total: data.total,
                records: tableData
            });
            setIsLoading(false);
        })
        .catch((error) => {
            displayError(
                error?.response?.data || { message: error?.message || 'Cannot reach API server. Is Django running on http://localhost:8000?' },
                'Load Failed',
            );
            setData({ total: 0, records: [] });
            setIsLoading(false);
        });
        }, [refreshKey]);
    
    return (

        <div id="outer-container"  className="App" > 
            <Sidebar pageWrapId={'page-wrap'} outerContainerId={'outer-container'} />
            <div id="page-wrap">
                <ListPageFloatingControls
                    formLink="/Permission"
                    addNewLabel="New Permission"
                    homeLink="/Home"
                    onExportCSV={handleCSVExport}
                    onExportPDF={handlePDFExport}
                />
                <div className="container page-content-rail">
                    <PremiumPageHeader
                        module="ADMIN"
                        title="List of User Permissions"
                        subtitle="Browse and manage role-based permissions."
                        modeLabel="VIEW MODE"
                    />
                    <div className="item-list-table-container">
                <div className="table-responsive">
                <ReactTableWrapper
                            title='List of Permission Form'
                            columns={columns}
                            data={data.records}
                            onRowEdit={onEditPermission}
                            onRowDelete={onDeletePermission}
                            onCSVExport={handleCSVExport}
                            onPDFExport={handlePDFExport}
                            isLoading={isLoading}
                        
                        />
                </div>
                </div>
                </div>
            </div>
        </div>

        
    );

}



export default PermissionTable;